/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";

import { BreadcrumbItem } from "@/components/shared/Breadcrumb/breadcrumb.types";

import type { OngProps } from "@/components/pages/Ong/ong.types";

export const useOngData = (ong: OngProps["ong"]) => {
  const ongData = useMemo(() => {
    const {
      name,
      description,
      long_description,
      since,
      state,
      city,
      vtex_pickup_id,
      sw,
      logo,
      gallery,
      loja,
      link,
      collection
    } = ong;

    const breadcrumb: BreadcrumbItem[] = [
      {
        href: "/ongs",
        label: "ONGs Parceiras"
      },
      {
        label: name,
        href: ""
      }
    ];

    const galleryList = gallery.map((image, index) => ({
      src: image.url,
      alt: image.name || `image ${index}`
    }));

    return {
      name,
      description,
      long_description,
      since,
      state,
      city,
      vtex_pickup_id,
      sw,
      collection,
      logo,
      loja,
      link,
      breadcrumb,
      gallery: galleryList
    };
  }, [ong]);

  return ongData;
};
